"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.concat.js");

var _react = require("react");

var _antd = require("antd");

var _featureinfo = require("../../util/featureinfo");

var _map = require("../../util/map");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useWmsGetFeatureInfo = function useWmsGetFeatureInfo() {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      features = _useState4[0],
      setFeatures = _useState4[1];

  var clearRequest = (0, _react.useCallback)(function () {
    setErrors(null);
    setFeatures(null);
  }, []);
  var sendRequest = (0, _react.useCallback)(function (map, layers, position) {
    var fetchOpts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      method: 'GET'
    };
    //retrieve coordinate from the point geometry
    var coordinate = position.getCoordinates(); //retrieve all the active leaf leayers

    var leafLayers = (0, _map.getLeafVisibleLayers)(layers);

    if (leafLayers.length === 0) {
      _antd.message.info("Please, activate the layers to retrieve the features!!!");

      return;
    } //retrieve map view and its resolution


    var view = map.getView();
    var viewResolution = view.getResolution();
    var proj = view.getProjection();
    var newStates = [];
    leafLayers.forEach(function (lyr, index) {
      newStates.push(true);
    });
    fetchOpts = _objectSpread(_objectSpread({}, fetchOpts), {}, {
      method: 'GET'
    });
    leafLayers.forEach(function (lyr, index) {
      var wmsSource = lyr.getSource();
      if (!wmsSource.getFeatureInfoUrl) return;
      var info_format = lyr.getSource().getParams().INFO_FORMAT;
      console.log('info_format:', info_format);
      if (!info_format) info_format = 'application/json';
      var url = wmsSource.getFeatureInfoUrl(coordinate, viewResolution, proj, {
        'INFO_FORMAT': info_format
      });
      console.log('WMS GetFeatureInfo Request:', url);
      fetch(url, fetchOpts).then(function (response) {
        if (!response.ok) {
          throw new Error(response);
        }

        if (info_format === 'application/json') return response.json();else return response.text();
      }).then(function (responseData) {
        console.log('WFS GetFeature Response:', responseData);
        var newFeatures = (0, _featureinfo.parseFeatureInfo)(responseData, info_format);
        setFeatures(function (prevFeatures) {
          if (prevFeatures && newFeatures) {
            return [].concat(_toConsumableArray(prevFeatures), _toConsumableArray(newFeatures));
          }

          return newFeatures;
        });
      }).catch(function (error) {
        setErrors(function (prevErrors) {
          if (prevErrors) {
            return [].concat(_toConsumableArray(prevErrors), [error]);
          }

          return [error];
        });

        _antd.message.info(error.message);
      });
    });
  }, []);
  return [sendRequest, clearRequest, errors, features];
};

var _default = useWmsGetFeatureInfo;
exports.default = _default;